import Approve from './Approve.container';

export default Approve;
